import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home'
import Center from '@/page/Center'
import Test from '@/page/Test'
import Contract from '@/page/Contract'
import SleepQ from '@/page/SleepQ'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/b2c/:centerid',
      name: 'B2c',
      component: Home
    },
    {
      path: '/center/:centerid/:groupid',
      name: 'center',
      component: Center
    },
    {
      path:'/test',
      name: 'test',
      component: Test
    },
    {
      path: '/contract',
      name: 'contract',
      component: Contract
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js